export function openFileBrowser({
  multiple = false,
  accept = "",
  webkitdirectory = false,
}: {
  multiple?: boolean;
  accept?: string;
  webkitdirectory?: boolean;
}): Promise<File[]> {
  const element = document.createElement("input");
  element.type = "file";
  element.multiple = multiple;
  element.webkitdirectory = webkitdirectory;
  element.accept = accept;
  return new Promise((resolve) => {
    element.addEventListener("change", () => {
      resolve(Array.prototype.slice.apply(element.files));
    });
    element.addEventListener("cancel", () => {
      resolve([]);
    });
    element.click();
  });
}
